export const OptimizationStatusConfig = [
  { value: 0, message: "Not Completed" },
  { value: 1, message: "Completed With Splitter" },
  { value: 2, message: "Completed Without Splitter" },
  { value: 3, message: "Not Assessed" },
];



// WEBPACK FOOTER //
// ./src/constants/optimizationStatusConfig.js